
const digest = 'a1477cd28ebba7aa0517ac1a874dc0b8cdffce3c76a492e5e218e03665aa5f07';
const classes = {"wrapper":"_wrapper_1gf1l_1","barcodeWrapper":"_barcodeWrapper_1gf1l_6","title":"_title_1gf1l_15"};
const css = `._wrapper_1gf1l_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1gf1l_1 ._barcodeWrapper_1gf1l_6 {
  -webkit-box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
  -moz-box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
  border: 1px solid #c9d5e0;
  text-align: center;
  padding: 20px;
  border-radius: 20px;
}
._wrapper_1gf1l_1 ._title_1gf1l_15 {
  font-size: 18px;
  font-weight: 600;
  color: #1d65d8;
  padding: 12px 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  